import { map, find, filter } from 'lodash';
import { defaultRegistrationTypeId } from '../../utils/registrationType';
export const LOAD_CAPACITY = 'event-widgets/capacity/LOAD_CAPACITY';
export const LOAD_SESSION_CAPACITY = 'event-widgets/capacity/LOAD_SESSION_CAPACITY';
function getSessionCapacityId(event, sessionId) {
  const sessionContainer = event.products.sessionContainer;
  if (!sessionContainer) {
    return [];
  }
  const sessionCollections = [
    sessionContainer.optionalSessions || {},
    ...map(sessionContainer.sessionGroups, group => group.sessions)
  ];
  const collection = find(sessionCollections, c => c[sessionId]);
  const session = collection && collection[sessionId];
  return session && session.capacityId;
}
export function getAllSessionCapacityIds(event) {
  const sessionContainer = event.products.sessionContainer;
  if (!sessionContainer || !sessionContainer.optionalSessions) {
    return [];
  }
  const sessionGroupCapacityIds = [];
  if (sessionContainer.sessionGroups) {
    map(sessionContainer.sessionGroups,
      group => map(group.sessions,
        session => sessionGroupCapacityIds.push(session.capacityId)));
  }
  const sessionCapacityIds = map(sessionContainer.optionalSessions, session => session.capacityId);
  return [...sessionGroupCapacityIds, ...sessionCapacityIds];
}

export const getRegTypeCapacityIds = (event, incomingRegTypes, regPackId) => {
  const { id: eventId, registrationTypes, isInTestMode: isTestMode } = event;
  let filteredRegTypes = (!!incomingRegTypes) ? incomingRegTypes : registrationTypes;
  // No regtype type is not considered in reg packs
  if (filteredRegTypes && regPackId) {
    filteredRegTypes = filter(filteredRegTypes, value => value && value.id
       && value.id !== defaultRegistrationTypeId);
  }
  if (!!regPackId) {
    return map(filteredRegTypes, type => regPackId + '::' + type.id);
  }
  return map(filteredRegTypes, type => eventId + '::' + type.id + ((isTestMode) ? '_testmode' : ''));
};

export const getAdmissionItemCapacityids = (event) => {
  const admissionItems = event.products.admissionItems;
  return map(admissionItems, admissionItem => admissionItem.capacityId);
};

export const getQuantityItemCapacityIds = (event) => {
  const quantityItems = event.products.quantityItems;
  return map(quantityItems, quantityItem => quantityItem.capacityId);
};

export const loadCapacityCounts = (capacity) => {
  return (dispatch) => {
    dispatch({ type: LOAD_CAPACITY, payload: { capacity } });
  };
};

export const loadSessionSelectionCapacityCounts = (capacity) => {
  return (dispatch) => {
    dispatch({ type: LOAD_SESSION_CAPACITY, payload: { capacity } });
  };
};

/*
* Creates a thunked action to load the capacity for the event admission items and sessions
* @param capacityClient - The client to retrieve the capacity information.
*/
export function loadCapacity(sessionId = null, regPackId) {
  return async (dispatch, getState) => {
    const { event, accessToken, clients: { capacityClient } } = getState();
    const regTypeCapacityIds = getRegTypeCapacityIds(event, null, regPackId);
    // sessionId not being null indicates that the event has a large number of sessions (# currently set as 100)
    // and therefore, only the (un)selected session's capacity will be loaded along with that of the regTypes,
    // admission items and the event.
    const sessionCapacityIds = sessionId ? [getSessionCapacityId(event, sessionId)] : getAllSessionCapacityIds(event);
    const admissionCapacityIds = getAdmissionItemCapacityids(event);
    const quantityItemCapacityIds = getQuantityItemCapacityIds(event);
    const eventCapacityId = event.capacityId;
    const capacityIds = [...sessionCapacityIds, ...admissionCapacityIds, ...eventCapacityId,
      ...regTypeCapacityIds, ...quantityItemCapacityIds];
    const capacity = await capacityClient.getCapacitySummaries(accessToken, capacityIds);
    if (sessionId !== null) {
      dispatch(loadSessionSelectionCapacityCounts(capacity));
    } else {
      dispatch(loadCapacityCounts(capacity));
    }
  };
}

export default function reducer(state, action) {
  switch (action.type) {
    case LOAD_CAPACITY:
      return action.payload.capacity;
    case LOAD_SESSION_CAPACITY: {
      const newState = { ...state, ...action.payload.capacity };
      return newState;
    }
    default:
      return state;
  }
}
